import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import storePersist from "../../../redux/storePersist";
import _ from 'lodash'
import { getCardData } from "../../../common/services/website-card.service";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { selectListItems } from "../../../redux/library/selector";
import { selectOneuserSubscriptionsQueryItems } from "../../../redux/oneuser-subscriptions/selector";
import * as R from "ramda"
import { oneuserSubscriptions } from "../../../redux/oneuser-subscriptions/action";
import { useAppDispatch } from "../../../hooks/hooks";
import { quotes } from "../../../redux/quotes/action";
import { leads } from "../../../redux/leads/action";
import { cargoLeads } from "../../../redux/cargo-lead/action";
import { library } from "../../../redux/library/action";
import { countries } from "../../../redux/countries/action";
import { states } from "../../../redux/states/action";
import { cmsSettings } from "../../../redux/cmsSettings/action";
import { selectCurrent } from "../../../redux/settings/selectors";



const LogisticHome = () => {
	const dispatch = useAppDispatch();
	let navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { tenantId, lightLogo, darkLogo } = result
	const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
	const libraryData = useSelector(selectListItems)
	const OneuserQuery = useSelector(selectOneuserSubscriptionsQueryItems)
	const statesItems = storePersist?.get("states")?.current?.items;
	const countriesItems = storePersist?.get("countries")?.current?.items;
	const logo1 = require("../../../assets/img/partner1.jpg")
	const logo2 = require("../../../assets/img/partner2.jpg")
	const logo3 = require("../../../assets/img/partner3.jpg")
	const logo4 = require("../../../assets/img/partner4.jpg")
	const logo5 = require("../../../assets/img/partner5.jpg")
	const logo6 = require("../../../assets/img/partner6.jpg")

	const [selectedOneuser, setSelectedOneuser] = useState<any>({

	});
	const resetForm = () => {
		setSelectedOneuser({
			Login: {
				Phone: "",
				Email: ""
			},
			UserProfile: {
				FirstName: "",
				LastName: "",
				PersonTitle: ""
			},
			ONEUserInfo: {
				Biography: null,
				PhotoUrl: null,
				IsONEUserVerified: true,
				StartupName: "",
				YearsInOperation: "",
				IsTechFirstInnovation: true,
				StageOfTheStartup: "",
				Sector: "",
				WebsiteLink: "",
				utm_source: null,
				utm_medium: null,
				utm_campaign: null,
				utm_term: null,
				utm_content: null
			},
			Account: {
				IsPersonAccount: true,
				Name: "ONE User 001",
				TypeId: 440
			},
			PrimaryAddress: {
				address1: "",
				address2: "",
				city: "",
				CountryId: "",
				StateProvinceId: "",
				ZipPostalCode: "",
				WebsiteLink: ""
			}
		});
	};

	const dummyData = [{

		src: "../../assets/img/image 1.png",

	},
	{
		src: "../../assets/img/image 1.png",

	}, {
		src: "../../assets/img/image 1.png",

	}, {
		src: "../../assets/img/image 1.png",

	}, {
		src: "../../assets/img/image 1.png",

	}]

	const handleSubmit = async (event: any) => {
		event.preventDefault();
		const data = {
			"Login": {
				"Phone": selectedOneuser?.Login?.Phone,
				"Email": selectedOneuser?.Login?.Email,
			},

			"UserProfile": {
				"FirstName": selectedOneuser?.UserProfile?.FirstName,
				"LastName": "",
				"PersonTitle": ""
			},
			"ONEUserInfo": {
				"Biography": null,
				"PhotoUrl": null,
				"IsONEUserVerified": true,
				"StartupName": selectedOneuser?.ONEUserInfo?.StartupName,
				"YearsInOperation": "",
				"IsTechFirstInnovation": true,
				"StageOfTheStartup": selectedOneuser?.ONEUserInfo?.StageOfTheStartup,
				"Sector": selectedOneuser?.ONEUserInfo?.Sector,
				"WebsiteLink": selectedOneuser?.PrimaryAddress?.WebsiteLink,
				"utm_source": null,
				"utm_medium": null,
				"utm_campaign": null,
				"utm_term": null,
				"utm_content": null
			},

			"Account": {
				"IsPersonAccount": true,
				"Name": "ONE User 001",
				"TypeId": 440
			},

			"PrimaryAddress": {
				"Address1": selectedOneuser?.PrimaryAddress?.address1,
				"Address2": selectedOneuser?.PrimaryAddress?.address2,
				"City": selectedOneuser?.PrimaryAddress?.city,
				"CountryId": selectedOneuser?.PrimaryAddress?.CountryId,
				"StateProvinceId": selectedOneuser?.PrimaryAddress?.StateProvinceId,
				"ZipPostalCode": selectedOneuser?.PrimaryAddress?.ZipPostalCode,
			}


		}
		await dispatch(oneuserSubscriptions.resetAction({ actionType: 'create' }))
		await dispatch(oneuserSubscriptions.create({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
			entity: 'Oneuser',
			jsonData: {
				records: [
					data
				]
			}
		}))

		await resetForm();

	}

	const deferredAPICalls = async () => {
		dispatch(quotes.resetAction({ actionType: 'create' }))
		await dispatch(leads.resetAction({ actionType: 'create' }))
		await dispatch(cargoLeads.resetAction({ actionType: 'create' }))
		if (storePersist.get('guestTokenMetadata').current?.success) {
			await dispatch(library.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`, entity: 'library' }))
			await dispatch(countries.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`, entity: 'countries' }))
			await dispatch(states.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`, entity: 'states' }))
			await dispatch(cmsSettings.list({ url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`, entity: 'cmsSettings', jsonData: {} }))
		}

	}

	useEffect(() => {
		(async () => {
			if (tenantId) {
				localStorage.removeItem('access-token')
				localStorage.removeItem('accessTokenMetadata')
				localStorage.removeItem('userProfile')
				deferredAPICalls();

			}
		})()
	}, [tenantId])

	const handleInnerFormChange: any = (event: any, field: string, data: any) => {
		const fields = R.split(
			'.',
			field
		);
		const value = { ...data, [fields[1]]: event }// inner data update
		setSelectedOneuser({ ...selectedOneuser, [fields[0]]: value });
	}
	//one user





	const HomePageBannerData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_HOME_PAGE_MAIN_BANNER') : null;
	const banner: any = (HomePageBannerData && HomePageBannerData[0]?.src ? encodeURI(HomePageBannerData[0]?.src) : require('./../../../assets/img/logisticsBanner.png'))
	const workProcessHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_HOME_PAGE_MAJOR_HIGHLIGHTS') : null;

	const homePageOurImapctHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_HOME_PAGE_OUR_IMPACT_HEADING') : null;
	const HomePageOurImpactContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_HOME_PAGE_OUR_IMPACT') : null;

	const workProcessData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_HOME_PAGE_MAJOR_HIGHLIGHTS_CONTENT') : null;


	const eMobilityHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_HOME_MAIN_PAGE_E_MOBILITY_HEADING') : null;

	const eMobilityData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_HOME_MAIN_PAGE_E_MOBILITY') : null;

	const serviceHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_HOME_MAIN_PAGE_SERVICE_HEADING') : null;

	const serviceData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONEX_HOME_MAIN_PAGE_SERVICE') : null;

	const HomePagePromoters: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'HOME_PAGE_PROMOTERS') : null;

	const copyRightsContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_COPYRIGHTS') : null;

	const handleNavigate = (path: any) => {
		navigate(`${path}`)
	}


	const HTMLContent: any = ({ htmlContent }: any) => {
		return (
			<div
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		);
	};
	const CargoPageBannerData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_CARGO_QDP_BANNER') : null;


	console.log('emobility heading', eMobilityHeading)
	return (
		<>

			<div className={`flex flex-col items-center justify-center w-full bg-white `} >

				{/* Banner Section */}
				{/* <div className="flex flex-col items-center justify-center w-full" style={{ backgroundImage: `url(${banner})` }}> */}
				<div className="flex flex-col items-center justify-center w-full" style={{ backgroundImage: `url(${banner})` }}>
					<div className="flex justify-around items-center p-1 w-full h-[650px] px-10">
						{/* Left side text section */}
						<div className="flex p-2 flex-col justify-between items-center w-[800px]">
							{/* <p className="text-4xl font-normal text-white text-center">{CargoPageBannerData[0]?.title}</p>
											<p className="text-xl pt-20 text-white text-center">{CargoPageBannerData[0]?.subTitle}</p> */}
							<p className="text-4xl font-normal text-white text-center"></p>
							<p className="text-xl pt-20 text-white text-center"></p>
						</div>

						{/* Right side form section */}
						<div className="w-1/3 flex justify-center items-start mt-20 rounded-2xl bg-white">
							<div className="w-full p-5 flex flex-col justify-center items-center rounded-2xl">
								<div className="text-2xl text-primary font-bold py-5">Record Your Interest</div>
								<div className=" w-full px-3 font-bold space-y-2">
									<div className="flex flex-row space-x-2 ">
										<div className=" w-full">
											<div className="border-0 font-normal">
												<input
													required
													type="text"
													name={"FirstName"}
													placeholder="Name"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value,
															'UserProfile.FirstName',
															selectedOneuser?.UserProfile
														);
													}}
													value={selectedOneuser?.UserProfile?.FirstName} />
											</div>
										</div>

										<div className=" w-full">
											<div className="border-0 font-normal">
												<input
													required
													type="email"
													name={"Email"}
													placeholder="Email"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value,
															'Login.Email',
															selectedOneuser?.Login
														);
													}}
													value={selectedOneuser?.Login?.Email} />
											</div>
										</div>


									</div>

									<div className="flex flex-row space-x-2 ">
										<div className=" w-full">
											<div className="border-0 font-normal">
												<input
													required
													maxLength={10}
													type="text"
													name={"Phone"}
													placeholder="Phone Number"
													pattern="\d{10}"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value.replace(/\D/g, ''),
															'Login.Phone',
															selectedOneuser?.Login
														);
													}}
													value={selectedOneuser?.Login?.Phone} />
												{selectedOneuser?.Login?.Phone && selectedOneuser?.Login?.Phone?.length < 10 && (
													<span className="text-red-600 text-xs">
														Please enter a valid number.
													</span>
												)}
											</div>

										</div>
										<div className=" w-full">
											<div className="border-0 font-normal">
												<input
													required
													type="text"
													name={"StartupName"}
													placeholder="Startup Name"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value,
															'ONEUserInfo.StartupName',
															selectedOneuser?.ONEUserInfo
														);
													}}
													value={selectedOneuser?.ONEUserInfo?.StartupName} />
											</div>
										</div>

									</div>

									<div className="flex flex-row space-x-2">
										<div className="w-1/2">
											<div className="border-0 font-normal">
												<select
													required
													name="StartupStage"
													className="w-full py-3 px-3 border-b-2 border-black text-base"
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value,
															'ONEUserInfo.StageOfTheStartup',
															selectedOneuser?.ONEUserInfo
														);
													}}
													value={selectedOneuser?.ONEUserInfo?.StageOfTheStartup || ''}
												>
													<option value="" disabled hidden>
														Select Stage Of The Startup
													</option>
													{libraryData?.result?.StartupStage?.length > 0 ? (
														libraryData.result.StartupStage.map((item: any, index: number) => (
															<option key={index} value={item.Text}>
																{item.Text}
															</option>
														))
													) : (
														<option value="" disabled>
															No options available
														</option>
													)}
												</select>
											</div>
										</div>

										<div className="w-1/2">
											<div className="border-0 font-normal">
												<select
													required
													name="StartupSector"
													className="w-full py-3 px-3 border-b-2 border-black text-base"
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value,
															'ONEUserInfo.Sector',
															selectedOneuser?.ONEUserInfo
														);
													}}
													value={selectedOneuser?.ONEUserInfo?.Sector || ''}
												>
													<option value="" disabled hidden>
														Select a Sector
													</option>
													{libraryData?.result?.StartupSector?.length > 0 ? (
														libraryData.result.StartupSector.map((item: any, index: number) => (
															<option key={index} value={item.Text}>
																{item.Text}
															</option>
														))
													) : (
														<option value="" disabled>
															No options available
														</option>
													)}
												</select>
											</div>
										</div>
									</div>

									<div className="flex flex-row space-x-2 ">
										<div className=" w-full">

											<div className="border-0 font-normal">
												<input
													required
													type="text"
													name={"WebsiteLink"}
													placeholder="Website link"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value,
															'ONEUserInfo.WebsiteLink',
															selectedOneuser?.ONEUserInfo
														);
													}}
													value={selectedOneuser?.ONEUserInfo?.WebsiteLink} />
											</div>
										</div>
									</div>

									<div className="flex flex-row space-x-2 ">
										<div className=" w-full">

											<div className="border-0 font-normal">
												<input
													required
													type="text"
													name={"address1"}
													placeholder="Building"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value,
															'PrimaryAddress.address1',
															selectedOneuser?.PrimaryAddress
														);
													}}
													value={selectedOneuser?.PrimaryAddress?.address1} />
											</div>
										</div>
										<div className=" w-full">

											<div className="border-0 font-normal">
												<input
													required
													type="text"
													name={"address2"}
													placeholder="Locality"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value,
															'PrimaryAddress.address2',
															selectedOneuser?.PrimaryAddress
														);
													}}
													value={selectedOneuser?.PrimaryAddress?.address2} />
											</div>
										</div>

									</div>

									<div className="flex flex-row space-x-2 ">
										<div className=" w-full">

											<div className="border-0 font-normal">
												<input
													required
													type="text"
													name={"city"}
													placeholder="city"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value,
															'PrimaryAddress.city',
															selectedOneuser?.PrimaryAddress
														);
													}}
													value={selectedOneuser?.PrimaryAddress?.city} />
											</div>
										</div>
										<div className=" w-full">

											<div className="border-0 font-normal">
												<input
													required
													type="text"
													name={"ZipPostalCode"}
													placeholder="Pincode"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleInnerFormChange(
															event.target.value,
															'PrimaryAddress.ZipPostalCode',
															selectedOneuser?.PrimaryAddress
														);
													}}
													value={selectedOneuser?.PrimaryAddress?.ZipPostalCode} />
											</div>
										</div>

									</div>

									<div className="flex flex-row space-x-2">

										<div className="w-full">
											<div className="border-0 font-normal">
												<select
													required
													name="country"
													className="w-full py-3 px-3 border-b-2 border-black text-base"
													onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.CountryId',
														selectedOneuser?.PrimaryAddress
													)}
													value={selectedOneuser?.PrimaryAddress?.CountryId || ''}
												>
													<option value="" disabled hidden>Select Country</option>

													{countriesItems?.map((country: any) => (
														<option key={country.Id} value={country.Id}>{country.Name}</option>
													))}

												</select>
											</div>
										</div>


										<div className="w-full">
											<div className="border-0 font-normal">
												<select
													required
													name="StateProvinceId"
													className="w-full py-3 px-3 border-b-2 border-black text-base"
													onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.StateProvinceId',
														selectedOneuser?.PrimaryAddress
													)}
													value={selectedOneuser?.PrimaryAddress?.StateProvinceId || ''}
												>
													<option value="" disabled hidden>Select State</option>
													{statesItems?.length > 0 ? (
														statesItems.map((state, index) => (
															<option key={index} value={state.Id}>
																{state.Name}
															</option>
														))
													) : (
														<option value="" disabled>No states available</option>
													)}
												</select>
											</div>
										</div>
									</div>

								</div>
								{/* <div className="text-[#405578]  text-[9px] pt-3">Wrong weight and sized will seized ypur package + Rs500 penality</div> */}

								<div className={`${isButtonLoading ? 'bg-primary/70' : 'bg-primary'} px-5 flex w-full flex-row items-center justify-center mt-5 mb-10 rounded-lg`}>
									<div
										onClick={handleSubmit}
										className="flex flex-row items-center justify-center text-white text-base my-3 font-bold cursor-pointer"
									>
										Register
										<div className={`pl-2 ${isButtonLoading ? 'visible' : 'invisible'}`}>
											<RotatingLines
												visible={true}
												width={'20'}
												strokeColor="#fff"
												strokeWidth="6"
												animationDuration="0.75"
												ariaLabel="rotating-lines-loading"
											/>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>


				{/* Impact Section - Below Banner */}
				<div className="w-full bg-[#f5f5f5] mt-10 py-16 px-6 flex flex-col items-center justify-center">
					<h2 className="text-3xl font-bold mb-10">
						{homePageOurImapctHeading && homePageOurImapctHeading[0]?.title ? (
							<>
								{homePageOurImapctHeading[0].title.split(' ').map((word, index, arr) => (
									<span
										key={index}
										className={index === arr.length - 1 ? 'text-primary' : 'text-black'}
									>
										{word}{' '}
									</span>
								))}
							</>
						) : (
							<>
								<span className="text-black">Our </span>
								<span className="text-orange-600">Impact</span>
							</>
						)}
					</h2>

					{/* first content */}
					<div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-0 w-full max-w-6xl text-center">
						{/* first content */}
						<div>
							<p className="text-4xl font-extrabold text-primary">
								{HomePageOurImpactContent ? HomePageOurImpactContent[0]?.title : null}
							</p>
							<p className="font-semibold mt-1">
								{HomePageOurImpactContent ? HomePageOurImpactContent[0]?.subTitle : null}
							</p>
						</div>
						{/* second content */}
						<div>
							<p className="text-4xl font-extrabold text-primary">
								{HomePageOurImpactContent ? HomePageOurImpactContent[1]?.title : null}
							</p>
							<p className="font-semibold mt-1">
								{HomePageOurImpactContent ? HomePageOurImpactContent[1]?.subTitle : null}
							</p>
						</div>
						{/* third content */}
						<div>
							<p className="text-4xl font-extrabold text-primary">
								{HomePageOurImpactContent ? HomePageOurImpactContent[2]?.title : null}
							</p>
							<p className="font-semibold mt-1">
								{HomePageOurImpactContent ? HomePageOurImpactContent[2]?.subTitle : null}
							</p>
						</div>

						{/* fourth content */}
						<div>
							<p className="text-4xl font-extrabold text-primary">
								{HomePageOurImpactContent ? HomePageOurImpactContent[3]?.title : null}
							</p>
							<p className="font-semibold mt-1">
								{HomePageOurImpactContent ? HomePageOurImpactContent[3]?.subTitle : null}
							</p>
						</div>
					</div>


					<div className="w-full mt-10 flex justify-center">
						<div className="w-full max-w-7xl px-10 border-l-4 border-primary pl-6 text-left text-gray-800 text-base leading-relaxed">
							{HomePageOurImpactContent ? HomePageOurImpactContent[0]?.description : null}
						</div>
					</div>





					{/* <p className="max-w-4xl text-center text-gray-800 text-base leading-relaxed px-4">
    At NSRCEL, we believe founders are the driving force behind India’s tech future. But scaling something extraordinary isn’t easy.
    The startup journey is as demanding as it is rewarding—and that’s where we come in. For 20 years, we’ve been more than just an
    incubator—we’re a launchpad for tech innovation, a network of industry leaders, and a powerhouse of resources designed to help
    entrepreneurs survive, scale, and thrive. Because when startups succeed, India leads the way.
  </p> */}

				</div>




				{/* Section 2 */}
				<div className="w-full flex items-center justify-center flex-col">
					<div className={`flex flex-col justify-center items-center w-full `}>
						<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
							<div className="text-3xl font-bold ">
								{workProcessHeading ? workProcessHeading[0]?.title : null}
							</div>
						</div>
						<div className="flex flex-row justify-around items-stretch w-full pt-10 px-10">
							{/* Card 1 */}
							<div className="relative flex flex-col justify-center items-center w-72 px-2">
								<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
									<img src={workProcessData && workProcessData[0]?.src ? workProcessData[0]?.src : 'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
								</div>
								<div className="flex-grow p-1 font-semibold text-lg text-center">
									{workProcessData ? workProcessData[0]?.title : null}
								</div>
								<div className="flex-grow p-1 text-center text-base min-h-[60px]">
									{workProcessData ? workProcessData[0]?.subTitle : null}
								</div>
							</div>

							{/* Card 2 */}
							<div className="relative flex flex-col justify-center items-center w-72 px-2">
								<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
									<img src={workProcessData && workProcessData[1]?.src ? workProcessData[1]?.src : 'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
								</div>
								<div className="flex-grow p-1 font-semibold text-lg text-center">
									{workProcessData ? workProcessData[1]?.title : null}
								</div>
								<div className="flex-grow p-1 text-center text-base min-h-[60px]">
									{workProcessData ? workProcessData[1]?.subTitle : null}
								</div>
							</div>

							{/* Card 3 */}
							<div className="relative flex flex-col justify-center items-center w-72 px-2">
								<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
									<img src={workProcessData && workProcessData[2]?.src ? workProcessData[2]?.src : 'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
								</div>
								<div className="flex-grow p-1 font-semibold text-lg text-center">
									{workProcessData ? workProcessData[2]?.title : null}
								</div>
								<div className="flex-grow p-1 text-center text-base min-h-[60px]">
									{workProcessData ? workProcessData[2]?.subTitle : null}
								</div>
							</div>

							{/* Card 4 */}
							<div className="relative flex flex-col justify-center items-center w-72 px-2">
								<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
									<img src={workProcessData && workProcessData[3]?.src ? workProcessData[3]?.src : 'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
								</div>
								<div className="flex-grow p-1 font-semibold text-lg text-center">
									{workProcessData ? workProcessData[3]?.title : null}
								</div>
								<div className="flex-grow p-1 text-center text-base min-h-[60px]">
									{workProcessData ? workProcessData[3]?.subTitle : null}
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Section 3 */}
				<div className="w-full flex items-center justify-center flex-col">
					<div className={`flex flex-col justify-center items-center w-full`}>
						<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
							<div className="text-3xl font-bold ">
								{eMobilityHeading ? eMobilityHeading[0]?.Title : null}
							</div>
						</div>
						<div className="flex flex-row justify-around items-stretch w-full my-10 mx-10 ">
							{/* Card 1 */}
							<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary `}>
								<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
									<HTMLContent htmlContent={eMobilityData ? eMobilityData[0]?.description : ''} />
								</div>
								<div className="flex-grow pt-4 font-semibold text-3xl text-light">
									{eMobilityData ? eMobilityData[0]?.title : null}
								</div>
								{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[0]?.subTitle : null}
                </div> */}
							</div>

							{/* Card 2 */}
							<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary `}>
								<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
									<HTMLContent htmlContent={eMobilityData ? eMobilityData[1]?.description : ''} />
								</div>
								<div className="flex-grow pt-4 font-semibold text-3xl text-light text-center">
									{eMobilityData ? eMobilityData[1]?.title : null}
								</div>
								{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[1]?.subTitle : null}
                </div> */}
							</div>

							{/* Card 3 */}
							<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary`}>
								<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
									<HTMLContent htmlContent={eMobilityData ? eMobilityData[2]?.description : ''} />
								</div>
								<div className="flex-grow pt-4 font-semibold text-3xl text-light text-center">
									{eMobilityData ? eMobilityData[2]?.title : null}
								</div>
								{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[2]?.subTitle : null}
                </div> */}
							</div>

							{/* Card 4 */}
							<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary `}>
								<div className="relative overflow-hidden bg-clip-border pt-14">
									<HTMLContent htmlContent={eMobilityData ? eMobilityData[3]?.description : ''} />
								</div>
								<div className="flex-grow pt-4 font-semibold text-3xl text-light">
									{eMobilityData ? eMobilityData[3]?.title : null}
								</div>
								{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[3]?.subTitle : null}
                </div> */}
							</div>
						</div>
					</div>
				</div>

				{/* Section 4 */}
				<div className="w-full flex items-center justify-center flex-col">
					<div className={`flex flex-col justify-center items-center w-full `}>
						<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
							<div className="text-3xl font-bold ">
								{serviceHeading ? serviceHeading[0]?.title : null}
							</div>
						</div>
						<div className="flex flex-row justify-around items-stretch w-full my-10 mx-5 px-20">
							{/* Card 1 */}
							<div className="relative flex flex-col justify-center items-center w-80 ">
								<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
									{/* <svg height="150" width="150" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#233c64" transform="matrix(-1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css"> </style> <g> <path d="M447.77,33.653c-36.385-5.566-70.629,15.824-82.588,49.228h-44.038v37.899h40.902 c5.212,31.372,29.694,57.355,62.855,62.436c41.278,6.316,79.882-22.042,86.222-63.341C517.428,78.575,489.07,39.969,447.77,33.653z "></path> <path d="M162.615,338.222c0-6.88-5.577-12.468-12.468-12.468H96.16c-6.891,0-12.467,5.588-12.467,12.468 c0,6.868,5.576,12.467,12.467,12.467h53.988C157.038,350.689,162.615,345.091,162.615,338.222z"></path> <path d="M392.999,237.965L284.273,340.452l-37.966,9.398v-86.619H0v215.996h246.307v-59.454l35.547-5.732 c16.95-2.418,29.396-6.692,44.336-15.018l46.302-24.228v104.432h132.435V270.828C504.927,202.618,428.016,202.43,392.999,237.965z M215.996,448.913H30.313v-155.37h185.683v63.805l-36.419,9.01c-15.968,4.395-25.708,20.518-22.174,36.696l0.298,1.247 c3.478,15.912,18.651,26.436,34.785,24.14l23.51-3.788V448.913z"></path> </g> </g></svg> */}
									<HTMLContent htmlContent={serviceData ? serviceData[0]?.description : ''} />
								</div>
								<div className="flex-grow p-1 font-semibold text-lg text-center">
									{serviceData ? serviceData[0]?.title : null}
								</div>
								<div className="flex-grow p-1 text-center text-base min-h-[60px]">
									{serviceData ? serviceData[0]?.subTitle : null}
								</div>
							</div>
							<div className=" h-40 mt-10 border-r-2 border-gray-500"></div>
							{/* Card 2 */}
							<div className="relative flex flex-col justify-center items-center w-80 ">

								<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
									<HTMLContent htmlContent={serviceData ? serviceData[1]?.description : ''} />
								</div>
								<div className="flex-grow p-1 font-semibold text-lg text-center">
									{serviceData ? serviceData[1]?.title : null}
								</div>
								<div className="flex-grow p-1 text-center text-base min-h-[60px]">
									{serviceData ? serviceData[1]?.subTitle : null}
								</div>

							</div>
							<div className=" h-40 mt-10 border-r-2 border-gray-500"></div>
							{/* Card 3 */}
							<div className="relative flex flex-col justify-center items-center w-80 ">
								<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
									<HTMLContent htmlContent={serviceData ? serviceData[2]?.description : ''} />
								</div>
								<div className="flex-grow p-1 font-semibold text-lg text-center">
									{serviceData ? serviceData[2]?.title : null}
								</div>
								<div className="flex-grow p-1 text-center text-base min-h-[60px]">
									{serviceData ? serviceData[2]?.subTitle : null}
								</div>
							</div>



						</div>
					</div>
				</div>

				{/* Promoters Section */}
				<div className="w-full bg-white py-16 flex flex-col items-center justify-center">
					<h2 className="text-3xl font-bold mb-6 text-center">
						{HomePagePromoters ? HomePagePromoters[0]?.title : null}
					</h2>
					<p className="text-center max-w-3xl text-gray-700 mb-10 px-4">
						{HomePagePromoters ? HomePagePromoters[0]?.subTitle : null}
					</p>

					{/* Logo row */}
					<div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-6 px-4 max-w-6xl">
						{(HomePagePromoters?.length > 0 ? HomePagePromoters : dummyData).map((item, index) => (
							<div key={index} className="flex items-center justify-center w-40 h-20">
								<img
									src={item?.src || 'https://via.placeholder.com/272x256'}
									alt={`promoter-${index}`}
									className="h-full object-contain"
								/>
							</div>
						))}
					</div>
				</div>




			</div >


		</>
	)
}

export default LogisticHome
